<template>
    <div class="wb-el-info-anchor"
         :style="{'top': top, 'left': left}">
        <div class="wb-el-info-container" :class="{'wb-el-info-transparent': !isTransparent}">
            <div class="wb-door-params" >
              <div class="wb-door-params-text">Ш</div>
              <input type="number" class="wb-door-params-input"
                     @keydown.delete.stop @keydown.backspace.stop
                     :value="+data?.width*1000" ref="doorW"/>
              <div class="wb-door-params-text">x</div>
              <div class="wb-door-params-text">В</div>
              <input type="number" class="wb-door-params-input"
                     @keydown.delete.stop @keydown.backspace.stop
                     :value="+data?.height*1000" ref="doorH"/>
              <div class="wb-door-params-text">x</div>
              <div class="wb-door-params-text">Г</div>
              <input type="number" class="wb-door-params-input"
                     @keydown.delete.stop @keydown.backspace.stop
                     :value="+data?.depth*1000" ref="doorD"/>
              <div class="wb-door-params-text">-</div>
              <input type="number" class="wb-door-params-input"
                     @keydown.delete.stop @keydown.backspace.stop
                     :value="+data?.floorHeight*1000" ref="boxFloorHeight"/>
              <div class="wb-door-params-text">мм</div>
              <NavbarCircleButton @click="() => {setSize()}">
                  <template #svg>
                      <SVGConfirm/>
                  </template>
              </NavbarCircleButton>

              <div class="wb-wb-door-params-btn-spacer"></div>

              <NavbarCircleButton @click="() => {deleteEl()}">
                  <template #svg>
                      <SVGDelete/>
                  </template>
              </NavbarCircleButton>
            </div>
        </div>
    </div>
</template>

<script>
import NavbarCircleButton from '@/UI/Components/ComponentsNavbar/NavbarCircleButton.vue';
import SVGDelete from '@/UI/Components/SVG/SVGDelete.vue';
import SVGConfirm from '@/UI/Components/SVG/SVGConfirm.vue';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { useUIOnlyStore } from '@/Store/storeUI';
import { deleteEl } from '@/lib/deleteEl';
import { $ } from '@/Engine/state';

export default {
    name: 'OverlayBoxParams',
    components: {
        SVGConfirm,
        SVGDelete,
        NavbarCircleButton,
    },
    setup() {
        const configurationStore = useConfigurationStore();
        const UIStore = useUIOnlyStore();
        return {
            configurationStore,
            UIStore,
        };
    },
    props: [
        'top',
        'left',
        'data',
    ],
    methods: {
        setSize() {
            const width = this.$refs.doorW.value;
            const height = this.$refs.doorH.value;
            const depth = this.$refs.doorD.value;
            const floorHeight = this.$refs.boxFloorHeight.value;
            console.log(width, height, depth);
            const selectedEl = this.UIStore.getSelectedSceneObject;
            const maxHeight=($.room.getHeight()*1000);
            if(+height>maxHeight) return;
            if((+width)<1||(+depth)<1||(+height)<1) return;
            if ((+width)>3000 || (+depth)>3000) return;
            this.configurationStore.setBoxSize(selectedEl.uuid, +width/1000, +height/1000, +depth/1000, +floorHeight/1000);
        },
        deleteEl,
    },
    computed: {
        isTransparent() {
            return this.UIStore.getElementInfoActive;
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";

.wb-el-info-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 100;
}

.wb-door-params {
    padding: 16px;
    height: 80px;
    width: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    gap: 8px;
    background-color: $gray1;
    color: $darkBlue;
    @include font-h1;
    transition: opacity 0.2s;
}

.wb-el-info-transparent {
    pointer-events: none;
    opacity: 0.4;
}


.wb-door-params-input {
    outline: none;
    border: 1px solid $white;
    background-color: $gray1;
    height: 40px;
    width: 80px;
    border-radius: 4px;
    padding: 0 8px;
}

.wb-door-params-input::-webkit-outer-spin-button,
.wb-door-params-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.wb-door-params-input {
    -moz-appearance: textfield;
}

.wb-door-params-text {
    @include wb-c-flex-center;
    margin: 0 3px;
    padding-bottom: 6px;
}

.wb-wb-door-params-btn-spacer {
    background-color: $gray2;
    margin: 0 15px;
    height: 100%;
    width: 1px;
}
</style>
